import script from "./whDOnceImg3_t1B.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg3_t1B.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg3_t1B.vue?vue&type=style&index=0&id=87ee1d5c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ee1d5c"]])

export default __exports__